// extracted by mini-css-extract-plugin
export default {"menu__wrapper":"PageMenu_menu__wrapper__7KDh-","active":"PageMenu_active__hq9GF","logout":"PageMenu_logout__8QSwH"};